/* Yaniko — камъни по зодия и по месец.

   Един и същ списък, показан по два начина: хората, които знаят зодията си,
   тръгват оттам, а онези, които помнят само месеца, тръгват от месеца. Месецът
   опира в две зодии и показваме и двете, вместо да гадаем вместо тях.

   Всяка гривна тук е истинска — мярката на бестселъра със сменен камък — и
   цената е сметната от двигателя на конфигуратора. */
(function () {
  'use strict';

  var D = window.YGK_DATA || {};
  var Z = window.YGK_ZODIAK || {};
  if (!Z.зодии || !Z.зодии.length) return;

  var GEM_IMG = {};
  (D.gems || []).forEach(function (g) { GEM_IMG[String(g.id)] = g.image; });

  var byId = {};
  Z.зодии.forEach(function (z) { byId[z.id] = z; });

  var root, view = 'zodii';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function money(v) { return v.toFixed(2).replace('.', ',') + ' €'; }

  /* Плаща се цяло евро — вариантите на продукта носител са през едно евро и
     конфигураторът закръгля до най-близкото цяло. Показваме същото число, за да няма изненада
     на касата. */
  function charged(v) { return Math.round(v); }


  /* Знаците на зодиите са букви, не емоджита. Без U+FE0E браузърът ги подава на
     емоджи шрифта и вместо тънък златен знак излиза шарено квадратче. */
  function sym(s) { return s + '\uFE0E'; }

  function simpleUrl(z) {
    return (D.simpleUrl || '/pages/napravi-grivna') + '?d=' + encodeURIComponent(z.код);
  }

  /* Кръгчето е цветът на камъка, а когато има снимка — самата снимка. Зарежда
     се след това, за да не стои дупка, докато мрежата се бави. */
  function dot(z, cls) {
    var d = el('span', cls);
    d.style.background = z.топче.hex;
    var src = z.топче.изображение && GEM_IMG[z.топче.изображение];
    if (src) {
      var img = new Image();
      img.onload = function () {
        /* Краткото background по-горе нулира background-size от CSS — без тези два
           реда снимката излиза в естествен размер и в кръгчето остава белият ѝ ъгъл. */
        d.style.backgroundImage = 'url("' + src + '")';
        d.style.backgroundSize = 'cover';
        d.style.backgroundPosition = 'center';
      };
      img.src = src;
    }
    return d;
  }

  function card(z) {
    var c = el('article', 'ygkz-card');

    var top = el('div', 'ygkz-card__top');
    top.appendChild(el('span', 'ygkz-card__sym', sym(z.символ)));
    top.appendChild(el('h3', 'ygkz-card__name', z.име));
    c.appendChild(top);
    c.appendChild(el('span', 'ygkz-card__when', z.срок + ' · ' + z.стихия.toLowerCase() + ' · ' + z.владетел));

    var stone = el('div', 'ygkz-stone');
    stone.appendChild(dot(z, 'ygkz-dot'));
    var n = el('span', 'ygkz-stone__n', z.камък);
    n.appendChild(el('small', null, z.топче.размер + ' мм · ' + z.камъни + ' камъка на гривна'));
    stone.appendChild(n);
    c.appendChild(stone);

    c.appendChild(el('p', 'ygkz-why', z.защо));

    var foot = el('div', 'ygkz-foot');
    var p = el('span', 'ygkz-price', money(charged(z.цена)));
    p.appendChild(el('small', null, 'черен конец · ' + z.злато + ' златни топчета 2 мм'));
    foot.appendChild(p);

    var go = el('a', 'ygkz-btn', 'Виж гривната');
    go.href = simpleUrl(z);
    go.addEventListener('click', function () {
      if (window.YGKShared) {
        window.YGKShared.track('select_zodiac', { sign: z.име, stone: z.камък, value: charged(z.цена), currency: 'EUR' });
      }
    });
    foot.appendChild(go);
    c.appendChild(foot);

    return c;
  }

  function chip(z) {
    var a = el('a', 'ygkz-chip');
    a.href = simpleUrl(z);
    a.appendChild(dot(z, 'ygkz-chip__dot'));
    var t = el('span', null, sym(z.символ) + ' ' + z.име + ' · ' + z.камък);
    a.appendChild(t);
    a.appendChild(el('span', 'ygkz-chip__d', z.срок.replace(/ – /, '–')));
    return a;
  }

  function renderZodii(box) {
    var grid = el('div', 'ygkz-grid');
    Z.зодии.forEach(function (z) { grid.appendChild(card(z)); });
    box.appendChild(grid);
  }

  function renderMeseci(box) {
    var list = el('div', 'ygkz-months');
    (Z.месеци || []).forEach(function (m) {
      var row = el('div', 'ygkz-month');
      row.appendChild(el('span', 'ygkz-month__n', m.име));
      var pair = el('div', 'ygkz-month__pair');
      m.зодии.forEach(function (id) { if (byId[id]) pair.appendChild(chip(byId[id])); });
      row.appendChild(pair);
      list.appendChild(row);
    });
    box.appendChild(list);
  }

  function render() {
    var box = root.querySelector('.ygkz-out');
    box.innerHTML = '';
    if (view === 'zodii') renderZodii(box); else renderMeseci(box);

    root.querySelectorAll('.ygkz-tab').forEach(function (b) {
      var on = b.getAttribute('data-view') === view;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function boot() {
    root = document.querySelector('[data-ygk-kamuni]');
    if (!root) return;

    var tabs = el('div', 'ygkz-tabs');
    tabs.setAttribute('role', 'tablist');
    [['zodii', 'По зодия'], ['meseci', 'По месец']].forEach(function (t) {
      var b = el('button', 'ygkz-tab', t[1]);
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('data-view', t[0]);
      b.addEventListener('click', function () {
        view = t[0];
        render();
        if (window.YGKShared) window.YGKShared.track('stones_view', { view: view });
      });
      tabs.appendChild(b);
    });
    root.appendChild(tabs);
    root.appendChild(el('div', 'ygkz-out'));

    // Месецът в адреса позволява да се праща връзка направо към нужния изглед.
    var q = new URLSearchParams(window.location.search);
    if (q.get('izgled') === 'meseci') view = 'meseci';

    render();

    var cta = el('div', 'ygkz-astral');
    var txt = el('div');
    txt.appendChild(el('h2', 'ygkz-astral__t', 'Знаеш ли часа, в който си роден/а?'));
    txt.appendChild(el('p', 'ygkz-astral__p',
      'Зодията е само Слънцето. Луната и асцендентът се сменят много по-бързо — '
      + 'асцендентът на всеки два часа — и с дата, час и град излизат три камъка вместо един.'));
    cta.appendChild(txt);
    var go = el('a', 'ygkz-btn', 'Астрална карта');
    go.href = D.astralUrl || '/pages/astralna-karta';
    cta.appendChild(go);
    root.appendChild(cta);

    root.appendChild(el('p', 'ygkz-note',
      'Границите на зодиите се местят с ден напред-назад според годината — ако си роден/а на границата, '
      + 'астралната карта ще ти каже точно. Кой камък на коя зодия отговаря е традиция, не наука; '
      + 'подбрали сме ги от камъните, които наистина изработваме, за да не ти препоръчаме нещо, което го няма.'));

    if (window.YGKShared) window.YGKShared.trackOnce('view_stones', { signs: Z.зодии.length });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
